import OBase from './OBase';

import * as Geometry from '../geometry';
import * as GHMath from '../../math';

export default class Amplitude extends OBase {
  update () {
    var vValTree = this.getVector3Input('Vector', false);
    var aValTree = this.getFloatInput('Amplitude');

    var output = this.getGenericObjectOutput('Vector');

    var dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(vValTree, aValTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        var vVal = outDataTrees[0].branches[i][j];
        let vec = new THREE.Vector3(vVal.x, vVal.y, vVal.z);

        vec.normalize();
        var aVal = Number(outDataTrees[1].branches[i][j]);

        vec.multiplyScalar(aVal);

        outTree.add(vec, outDataTrees[0].paths[i]);
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Amplitude.js